<!-- Page Wrapper -->
<div id="wrapper">
    <app-sidebar></app-sidebar>
  
    <!-- End of Sidebar -->
  
    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">
  
      <!-- Main Content -->
      <div id="content">
  
        <!-- Topbar -->
        <app-header></app-header>
        <!-- End of Topbar -->
  
        <!-- Begin Page Content -->
        <div class="container-fluid">
  
          <!-- Page Heading -->
          <!-- <div class="d-sm-flex align-items-center justify-content-between mb-4 dashboard-wrap">
            <div class="dashboard-content">
              <h1 class="h3 mb-0 text-gray-800 text-center">Welcome to Dashboard</h1>
            </div>
          </div> -->

  
<div class="card">
  <div class="card-header">
    
   
    
    <!-- START TABS DIV -->
    <div class="tabbable-responsive">
      <div class="tabbable">
        <h3 class="px-3" *ngIf="productData"><a class="breadcrum" [routerLink]="['/product-list']"> Products</a> > {{productData[0].payload.doc.data().name}}</h3>
      </div>
    </div>
  </div>
  <div class="card-body">
    
    <div class="tab-content">
      <div class="tab-pane fade show active" id="first" role="tabpanel" aria-labelledby="first-tab">
        <div class="p-5">
      <div class="container" *ngIf="productData && productData.length>0"> 
            <!-- <form class="user"> -->
              <div class="form-group row">
                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">SKU: </label>
              </div>

                <div class="col-sm-9 mb-3 mb-sm-0">
                    {{productData[0].payload.doc.data().sku}}
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Name: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().name}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Description: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().description}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Price: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0" >
                  <span *ngIf="productData[0].payload.doc.data().price">
                    $ {{productData[0].payload.doc.data().price}}
                  </span>
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Image: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  <span *ngFor="let item of productData[0].payload.doc.data().pictures">
                    <img class="mx-2 my-2" src={{item.download_url}} height="90" width="90">
                  </span>
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Dimensions (Length): </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().dimensions_length}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Dimensions (width): </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().dimensions_width}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Dimensions (depth): </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().dimensions_depth}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Dimensions (height): </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().dimensions_height}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Weight: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().weight}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Shape: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().shape}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Style: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().style}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">color: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().color}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Video: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().video}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">Selling Price: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0">
                  {{productData[0].payload.doc.data().price_selling}}
                </div>

                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label style="font-weight:600">GKC Price: </label>
                </div>
                <div class="col-sm-9 mb-3 mb-sm-0" *ngIf="priceGKC">
                  {{priceGKC}}
                </div>

              </div>
              
             
            <!-- </form> -->
      </div>
            <hr>
            
          </div>
      </div>
  
  </div>
    <!-- END TABS DIV -->
    
  </div>
  




  
  </div>
  
  
        </div>
        <!-- /.container-fluid -->
  
  
  
  
      </div>
      <!-- End of Main Content -->
  
      <!-- Footer -->
      <app-footer></app-footer>
      <!-- End of Footer -->
  
    </div>
    <!-- End of Content Wrapper -->
  
  </div>
  <!-- End of Page Wrapper -->
  
  <!-- Scroll to Top Button-->
  <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
  </a>
  
  